"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.all = exports.cond = exports.range = exports.zip = void 0;
/**
 * Return a new array alternating the contents of array1 and array1
 *
 */
function zip(array1, array2) {
    var result = [];
    var i;
    for (i = 0; i < array1.length && i < array2.length; i++) {
        result.push(array1[i]);
        result.push(array2[i]);
    }
    var remaining = array1.length > array2.length ? array1 : array2;
    for (var j = i; j < remaining.length; j++) {
        result.push(remaining[j]);
    }
    return result;
}
exports.zip = zip;
/**
 * Returns an array of integers
 * @param start (optional) the starting number, inclusive
 * @param stop the stop number, not inclusive
 * @param step (optional) the increment / decrement step
 */
function range(arg1, arg2, arg3) {
    var stop = arguments.length > 1 ? arg2 : arg1;
    var start = arguments.length > 1 ? arg1 : 0;
    var step = arguments.length > 2 ? arg3 : 1;
    var result = [];
    // detect invalid arguments
    if (step === 0)
        throw new Error("step argument must not be zero");
    // define a predicate to detect the end of range
    var endP = step > 0 ? function (i, end) { return i < end; } : function (i, end) { return i > end; };
    for (var i = start; endP(i, stop); i += step) {
        result.push(i);
    }
    return result;
}
exports.range = range;
function cond() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var _b = args_1[_a], pred = _b[0], expr = _b[1];
        if (pred)
            return expr;
    }
}
exports.cond = cond;
/**
 * Return true if `predicate` is true for all `elements`
 *
 */
function all(elements, predicate) {
    for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
        var element = elements_1[_i];
        if (!predicate(element))
            return false;
    }
    return true;
}
exports.all = all;
